import Aldo from 'assets/svg/Aldo.svg';
import classNames from 'classnames';
import BankHeaderIcon from 'components/atoms/SVG/BankHeaderIcon';
import DocumentRepositoryHeaderIcon from 'components/atoms/SVG/DocumentRepositoryHeaderIcon';
import RevenuesHeaderIcon from 'components/atoms/SVG/RevenuesHeaderIcon';
import TaxesHeaderIcon from 'components/atoms/SVG/TaxesHeaderIcon';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';
import { World } from 'types/shared/worlds';
import ExpensesHeaderIcon from '../../atoms/SVG/ExpensesHeaderIcon';
import type { HeaderProps } from './Header.types';

const Header: FC<HeaderProps> = ({
  headerTitle,
  headerControllers,
  children,
  className = '',
  childrenClasses,
  color,
  customIcon,
}): JSX.Element => {
  const worldColor = useWorldTheme() as World;
  const theme = color || worldColor;
  const headerIconMap: Record<World, JSX.Element> = {
    [World.BANK]: (
      <div className="absolute rounded-bl-xl overflow-hidden bottom-0 left-0">
        <BankHeaderIcon />
      </div>
    ),
    [World.REVENUES]: (
      <div className="absolute rounded-bl-xl overflow-hidden bottom-0 left-0">
        <RevenuesHeaderIcon />
      </div>
    ),
    [World.EXPENSES]: (
      <div className="absolute rounded-bl-xl overflow-hidden bottom-0 left-0">
        <ExpensesHeaderIcon />
      </div>
    ),
    [World.TAXES]: (
      <div className="absolute bottom-0 left-0">
        <TaxesHeaderIcon />
      </div>
    ),
    [World.SETTINGS]: (
      <div className="absolute rounded-br-xl bottom-0 right-0 overflow-hidden">
        <img src={Aldo} alt="Aldo" className="h-20 -mb-2" />
      </div>
    ),
    [World.REPOSITORY]: (
      <div className="absolute bottom-0 left-0">
        <DocumentRepositoryHeaderIcon />
      </div>
    ),
  };

  const headerBGMap: Record<World, string> = {
    [World.BANK]: 'bg-bank-300',
    [World.REVENUES]: 'bg-revenues-300',
    [World.EXPENSES]: 'bg-expenses-300',
    [World.TAXES]: 'bg-taxes-300',
    [World.SETTINGS]: 'bg-taxes-50',
    [World.REPOSITORY]: 'bg-primary-100',
  };
  return (
    <div
      className={classNames(
        'flex relative justify-between px-12 py-3.5 rounded-xl items-center',
        headerBGMap[theme],
        className,
      )}
    >
      {customIcon || headerIconMap[theme]}
      {headerTitle}
      <div className={classNames('flex-1 px-10', childrenClasses)}>
        {children}
      </div>
      <div>{headerControllers}</div>
    </div>
  );
};

export default Header;
